<div class="flex items-center gap-2 text-gray-900 font-medium text-sm cursor-pointer" [routerLink]="link">
  <img ngSrc="/assets/images/icon-back.svg" [width]="24" [height]="24" />
  <span>{{ text }}</span>
</div>
